module.exports = __webpack_public_path__ + "static/media/bear.9bac22bc.png";